import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'

import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

export const TRN_CREATOR_FETCH = 'TRN_CREATOR_FETCH'
export const TRN_CREATOR_FETCH_CANCELED = 'TRN_CREATOR_FETCH_CANCELED'
export const TRN_CREATOR_FETCH_ERROR = 'TRN_CREATOR_FETCH_ERROR'
export const TRN_CREATOR_FETCH_FULFILLED = 'TRN_CREATOR_FETCH_FULFILLED'

export const creatorFetch = () => ({
  payload: null,
  type: TRN_CREATOR_FETCH,
})

export const creatorFetchFulfilled = (payload) => ({
  payload,
  type: TRN_CREATOR_FETCH_FULFILLED,
})

export const creatorFetchCanceled = () => ({
  payload: null,
  type: TRN_CREATOR_FETCH_CANCELED,
})

export const creatorFetchError = (payload) => ({
  payload,
  type: TRN_CREATOR_FETCH_ERROR,
})

export const creatorFetchEpic = (action$) =>
  action$.pipe(
    ofType(TRN_CREATOR_FETCH),
    mergeMap((action) =>
      epicServerRequest('get', `${APP.api_url}/sports/tournaments/creator`, action).pipe(
        map(epicResponseHandler(creatorFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(TRN_CREATOR_FETCH_CANCELED))),
        catchError(epicErrorHandler(creatorFetchError, action)),
      ),
    ),
  )
